module.exports = __webpack_public_path__ + "img/felipe_cordoves.7edeb4eb.png";